import { AlphaWCircleIcon } from './AlphaWCircleIcon';

/**
 * author: Contributors
 * id 8718E128-006E-4009-A718-A104B4C8E3A4
 * name alpha-w-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-w-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterWCircleIcon = AlphaWCircleIcon;
export default LetterWCircleIcon